import { observer } from "mobx-react";
/**
 * Show a banner from a given record in "Consent" table.
 */ const ConsentRecordBanner = observer((param)=>{
    let { record, visible, onClose, replayBannerRecord } = param;
/* Silence is golden... Until you have PRO Version! */ });
export { ConsentRecordBanner };
